import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {CatalogModule} from '../catalog/catalog.module';
import {ContextDataModule} from '../context-data';
import {ErrorHandlingModule} from '../error-handling';
import {CoreModule} from '../service';
import {EntryComponent} from './entry/entry.component';
import {LayoutComponent} from './layout/layout.component';
import {AddOnFooterComponent} from './layout/components/add-on-footer/add-on-footer.component';
import {AddOnHeaderComponent} from './layout/components/add-on-header/add-on-header.component';
import {LoadingOverlayComponent} from './layout/components/loading-overlay/loading-overlay.component';
import {PageTitleComponent} from './layout/components/page-title/page-title.component';
import {RedirectCheckoutLoaderComponent} from './redirect-checkout-loader/redirect-checkout-loader.component';
import {SeFeFooterComponent} from './se-fe-footer/se-fe-footer.component';
import {CartModule} from '../shopping-cart/cart.module';
import {SeFeComponentsModule} from '../../se-fe-components.module';
import {RouterModule} from '@angular/router';
import {LetDirective} from '@ngrx/component';
import {EventEffects} from '../event-emitter/event.effects';
import {DividerComponent} from './divider/divider.component';

const components = [
  AddOnFooterComponent,
  AddOnHeaderComponent,
  DividerComponent,
  EntryComponent,
  LayoutComponent,
  LoadingOverlayComponent,
  PageTitleComponent,
  RedirectCheckoutLoaderComponent,
  SeFeFooterComponent,
];

@NgModule({
  declarations: [...components],
  imports: [
    CartModule,
    CatalogModule,
    CommonModule,
    CoreModule,
    ContextDataModule,
    EffectsModule.forFeature([EventEffects]),
    ErrorHandlingModule,
    LetDirective,
    SeFeComponentsModule,
    RouterModule,
  ],
  exports: [...components],
})
export class CommonComponentsModule {}
